import { getOptions } from 'utils/inputSelect';

import {
  BusinessEntityStructure,
  CompanyOwnersAmount,
  HoldLicense,
  InstallProductsYouSell,
  MainContactPosition,
  PrimaryHomeImprovementCategory,
} from './contractorApplication.enums';

export const FEDERAL_TAX_ID_WITH_DASH_MAX_LENGTH = 10;
export const YEARS_IN_BUSINESS_MAX_LENGTH = 3;
export const CONTRACTOR_SAME_ADDRESSES_MAP = {
  intermediary_corporate_address: 'intermediary_mailing_address',
  intermediary_corporate_city: 'intermediary_city',
  intermediary_corporate_state: 'intermediary_state',
  intermediary_corporate_zip_code: 'intermediary_zip_code',
};
export const DEPRECATED_FEDERAL_TAX_IDS = ['00-0000000'];
export const DEFAULT_REQUIRED_MESSAGE = 'The Answer is required';
export const ALREADY_EXISTING_EMAIL_ERROR_MESSAGE = 'Email already exists';
export const MAX_INTERMEDIARY_OWNERS = 4;
export const MIN_PERCENTAGE_OWNED = 25;
export const MAX_PERCENTAGE_OWNED = 100;
export const PERCENT_PLACEHOLDER = '%';

export const BUSINESS_ENTITY_STRUCTURE_OPTIONS = getOptions(BusinessEntityStructure);
export const PRIMARY_HOME_IMPROVEMENT_CATEGORY_OPTIONS = getOptions(PrimaryHomeImprovementCategory);
export const DO_YOU_INSTALL_PRODUCTS_OPTIONS = getOptions(InstallProductsYouSell);
export const HOLD_LICENSE_OPTIONS = getOptions(HoldLicense);
export const MAIN_CONTACT_POSITION_OPTIONS = getOptions(MainContactPosition);
export const COMPANY_OWNERS_AMOUNT_OPTIONS = getOptions(CompanyOwnersAmount);

export const ASSOCIATED_MANUFACTURE_TOOLTIP_TEXT = 'This could be an associated distributor and/or supplier as well.';
export const BUSINESS_TRADE_NAME_TOOLTIP_TEXT = 'This is what your customers will see.';
export const SOMEONE_ELSE_OPTION = 'Someone else';
